const prefix = 'ahyc:draft:v1:'
const ttl = 7 * 24 * 60 * 60 * 1000
export function draftKey(employeeId, kind, id) {
  return prefix + employeeId + ':' + kind + ':' + id
}
export function readDraft(key) {
  try {
    const draft = JSON.parse(localStorage.getItem(key) || 'null')
    if (!draft) return null
    if (Date.now() - draft.savedAt > ttl) {
      localStorage.removeItem(key)
      return null
    }
    return draft
  } catch (e) {
    return null
  }
}
export function writeDraft(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify({ savedAt: Date.now(), value }))
    return true
  } catch (e) {
    return false
  }
}
export function removeDraft(key) {
  try {
    localStorage.removeItem(key)
    return true
  } catch (e) {
    return false
  }
}



// WEBPACK FOOTER //
// ./src/common/draft.js